<div class="d-flex flex-column">
  <div class="d-flex flex-column align-items-center justify-content-center file-upload-container"
       [ngClass]="{'file-upload-over': isFileOver, 'file-upload-leave': !isFileOver}"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)">
    <div class="d-flex align-items-center justify-content-center">
      <button mat-flat-button
              class="file-upload-button"
              (click)="selectedFile.click()">
        <mat-icon>folder_open</mat-icon>
        {{'t.fileUploadBrowse' | translate}}...
      </button>
      <input type="file"
             #selectedFile
             [accept]="acceptedFileExtsAttr$()"
             (change)="onChange($event)"
             [multiple]="fileUploadConfigModel.multiple$()"
             hidden />
    </div>
    <div class="d-flex align-items-center justify-content-center">
      {{'t.fileUploadDrag' | translate}}
    </div>

    <p *ngIf="fileUploadStatesModel.filesLoading$()" class="loading-files">{{'t.fileUploadMsg1' | translate}}</p>

    <ul *ngIf="fileObjectsModel.fileObjects$()" class="w-100">
      <li *ngFor="let fileObject of fileObjectsModel.fileObjects$()" class="d-flex align-items-center justify-content-between">
        <link-progress-bar *ngIf="fileObject.isLoading" [loading]="fileObject.isLoading!"></link-progress-bar>
        <div *ngIf="fileObject.isLoading">{{'t.fileUploadMsg2' | translate}}</div>
        <div *ngIf="!fileObject.isLoading" class="d-flex align-items-center file-name-wrapper">
          <div class="cpl-icon-check"></div>
          @if (fileObject.url) {
            <a [href]="fileObject.url" target="_blank">{{fileObject.name}}</a>
          }
          @else if(fileObject.fileMetadata && fileObject.fileMetadata.fileURL) {
            <a [href]="fileObject.fileMetadata.fileURL" target="_blank">{{fileObject.name}}</a>
          }
          @else {
            <a (click)="onDirectDownloadClicked(fileObject)">{{fileObject.name}}</a>
          }
        </div>
        <button type="button"
                class="cpl-icon-close"
                *ngIf="fileObject.isLoading === false"
                (click)="onRemoveFileClicked(fileObject)">
        </button>
      </li>
    </ul>
  </div>
</div>

<div class="d-flex align-items-center justify-content-between">
  <div [tooltip]="infoMsg" placement="right" class="d-flex align-items-center image-requirements">
    <span class="cpl-icon-info"></span>
    <span>{{'t.fileUploadReq' | translate}}</span>
  </div>
  <div id="errors">
    <small class="d-flex flex-column align-items-end text-danger"
           *ngIf="fileUploadStatesModel.extErrors$().length > 0">
      <div>
        <span class="cpl-icon-warning"></span>
        <span>{{extensionErrorMessage}}</span>
      </div>
      <div>{{ fileUploadStatesModel.extErrors$() | concatenate:', ':'and' }}</div>
    </small>
    <small class="d-flex flex-column align-items-end text-danger"
           *ngIf="fileUploadStatesModel.sizeErrors$().length > 0">
      <div>
        <span class="cpl-icon-warning"></span>
        <span>{{sizeErrorMessage}}</span>
      </div>
      <div>{{ fileUploadStatesModel.sizeErrors$() | concatenate:', ':'and' }}</div>
    </small>
    <small class="d-flex flex-column align-items-end text-danger"
           *ngIf="fileUploadStatesModel.resolutionErrors$().length > 0">
      <div>
        <span class="cpl-icon-warning"></span>
        <span>{{resolutionErrorMessage}}</span>
      </div>
      <div>{{ fileUploadStatesModel.resolutionErrors$() | concatenate:', ':'and' }}</div>
    </small>
    <div class="text-danger" *ngIf="fileUploadStatesModel.overwriteError$()">{{overwriteErrorMessage}}</div>
  </div>
</div>

<ng-template #infoMsg>
  <ul>
    <li *ngIf="extensionInfoMessage">{{extensionInfoMessage}}</li>
    <li *ngIf="minResolutionInfoMessage">{{minResolutionInfoMessage}}</li>
    <li *ngIf="maxResolutionInfoMessage">{{maxResolutionInfoMessage}}</li>
    <li *ngIf="sizeInfoMessage">{{sizeInfoMessage}}</li>

    @let additionalRequirementMessages = fileUploadConfigModel.additionalRequirementMessages$();

    @if(additionalRequirementMessages && additionalRequirementMessages.length > 0) {
      <li *ngFor="let msg of additionalRequirementMessages">{{msg}}</li>
    }
  </ul>
</ng-template>
